import { useEffect, useRef, useState } from 'react';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import Head from 'next/head';

import Slider from 'react-slick';

import { Wrapper } from '@/styles/pages';

import { MouseStyle } from '@/components/Mouse/styles';
import api from '@/services/api';
import { gaSendEvent } from '@/models/gaEvent';
import {
  faArrowRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDevice from '@/hooks/device';


const Index = () => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  const [posts, setPosts] = useState([]);
  const heroSection = useRef(null);

  const isMobile = useDevice('(max-width: 1500px)');

  const settings = {
    infinite: true,
    arrows: false,
    speed: 300,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          variableWidth: true
        }
      },

      {
        breakpoint: 10000,
        settings: 'unslick'
      }
    ]
  };

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: -180,
          right: 200,
          background: 'rgba(34, 83, 245, 0.2)',
          borderRadius: '27px',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <FontAwesomeIcon
          style={{
            color: '#2253F5',
            fontSize: 14
          }}
          icon={faChevronRight}
        />
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;

    return (
      <div
        onClick={onClick}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: -180,
          right: 250,
          background: 'rgba(34, 83, 245, 0.2)',
          borderRadius: '27px',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <FontAwesomeIcon
          style={{
            color: '#2253F5',
            fontSize: 14
          }}
          onClick={onClick}
          icon={faChevronLeft}
        />
      </div>
    );
  }

  const settings1 = {
    centerMode: true,
    infinite: true,
    centerPadding: '200',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0',
          arrows: false
        }
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0',
          arrows: false
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0'
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0'
        }
      }
    ]
  };

  const goToHeroSection = () => {
    window.scrollTo({ top: heroSection.current.offsetTop, behavior: 'smooth' });
  };

  useEffect(() => {
    const getPosts = async () => {
      try {
        const { data } = await api.get('/posts', {
          params: {
            per_page: 3,
            _embed: 0
          }
        });
        setPosts(data);
      } catch (e) {
        console.log(e);
      }
    };
    getPosts();
  }, []);

  return (
    <>
      <Head>
        <title data-i18n="title">{t('title')}</title>
        <meta
          data-i18n="description"
          data-i18n-attr="content"
          property="og:description"
          name="description"
          content={t('description')}
        />

        <meta
          property="og:image"
          content="https://i.ibb.co/JBB9NZw/meta-site.png"
        />
      </Head>

      <Wrapper>
        <div className="hero-1">
          <h1 data-i18n="hero-1.h1">{t('hero-1.h1')}</h1>
          <p data-i18n="hero-1.p">{t('hero-1.p')}</p>
          <a
            data-i18n="hero-1.a"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              gaSendEvent('Button', 'Home', 'Header');
              goToHeroSection();
            }}
            style={{
              marginBottom: '30px'
            }}
            className="btn"
          >
            {t('hero-1.2.a')}
          </a>
          <a href="#main">
            <MouseStyle />
          </a>
        </div>
        <div className="apps" />
        {locale === 'br' && (
          <div className="containerSlider">
            <div className="sliderLogo">
              {!isMobile && <p style={{
                fontFamily: 'Montserrat',
                fontStyle: 'italic',
                fontWeight: 500,
                fontSize: 20,
                marginLeft: 136,
                marginBottom: -14,
                color: '#FCFF7C',
              }}>Cloudez na mídia</p>}
              <Slider {...settings}>
                <a
                  style={{ width: 150 }}
                  href={t('links.yahoo')}
                  target="_blank"
                >
                  <img width="110px" src="/hero/yahoo.svg" alt="Yahoo" />
                </a>
                <a style={{ width: 150 }} href={t('links.it')} target="_blank">
                  <img
                    style={{ height: '45px' }}
                    width="108px"
                    src="/hero/it.svg"
                    alt="It Forum"
                  />
                </a>
                <a style={{ width: 80 }} href={t('links.ig')} target="_blank">
                  <img width="38px" src="/hero/ig.svg" alt="Ig" />
                </a>
                <a
                  style={{ width: 190 }}
                  href={t('links.gazeta')}
                  target="_blank"
                >
                  <img
                    width="145px"
                    src="/hero/gazeta.svg"
                    alt="Gazeta do Povo"
                  />
                </a>
                <a
                  style={{ width: 200 }}
                  href={t('links.canalTech')}
                  target="_blank"
                >
                  <img
                    width="160px"
                    src="/hero/canalTech.svg"
                    alt="Canal Tech"
                  />
                </a>
                <a
                  style={{ width: 160 }}
                  href={t('links.propMark')}
                  target="_blank"
                >
                  <img width="120px" src="/hero/propMark.svg" alt="PropMark" />
                </a>
                <a
                  style={{ width: 150 }}
                  href={t('links.exame')}
                  target="_blank"
                >
                  <img width="120px" src="/hero/exame.svg" alt="Exame" />
                </a>
              </Slider>
            </div>
          </div>
        )}
        <main id="main">
          <div className="background">
            <div className="hero">
              <h1 data-i18n="hero.h1">{t('hero.h1')}</h1>
              <p data-i18n="hero.p">{t('hero.p')}</p>
            </div>

            <div className="divbackground" >
              <Image
                priority
                alt="bg"
                src='/bg.png'
                layout='fill'
                objectFit='cover'
              />
            </div>

            <div className="mobile-step1">
              <Image
                alt="mobile_step1"
                src='/mobile_step1.svg'
                width={130}
                height={225}
              />
            </div>

            <section className="section" style={{ marginTop: '380px' }}>
              <div className="text">
                <h1 data-i18n="section1.h1">{t('section1.h1')}</h1>
                <p data-i18n="section1.p">{t('section1.p')}</p>
              </div>

              <Image
                alt="techs"
                src="/techs.png"
                width="525"
                height="477"
              />
            </section>

            <div className="mobile-step2">
              <Image
                alt="mobile_step2"
                src='/mobile_step2.svg'
                width={130}
                height={435}
              />
            </div>

            <section className="section" style={{ marginTop: '300px' }}>
              <div style={{ width: '50%' }} />
              <div className="text">
                <h1 data-i18n="section2.h1">{t('section2.h1')}</h1>
                <p data-i18n="section2.p">{t('section2.p')}</p>
              </div>
            </section>

            <section className="section" style={{ marginTop: '250px' }}>
              <Image
                alt="layback"
                src="/layback.png"
                width="550"
                height="554"
              />
              <div style={{ width: '50%' }} />
            </section>


            <div className="mobile-step3">
              <Image
                alt="mobile_step3"
                src='/mobile_step3.svg'
                width={130}
                height={435}
              />
            </div>

            <section className="section" style={{ marginTop: '100px' }}>
              <div className="text">
                <h1 data-i18n="section3.h1">{t('section3.h1')}</h1>
                <p data-i18n="section3.p">{t('section3.p')}</p>
              </div>
              <div style={{ width: '50%' }} />
            </section>

            <section className="section" style={{ marginTop: '310px', marginLeft: '-30px' }}>
              <div style={{ width: '50%' }} />
              <Image
                alt="partners"
                src="/partners.png"
                width="550"
                height="519"
              />
            </section>

            <div className="mobile-step4">
              <Image
                alt="mobile_step4"
                src='/mobile_step4.svg'
                width={130}
                height={435}
              />
            </div>

            <section className="section" style={{ marginTop: '100px' }}>
              <div style={{ width: '50%' }} />
              <div className="text">
                <h1 data-i18n="section4.h1">{t('section4.h1')}</h1>
                <p data-i18n="section4.p">{t('section4.p')}</p>
              </div>
            </section>

            <section className="section" style={{ marginTop: '200px' }}>
              <Image
                alt="phone"
                src="/phone.png"
                width="550"
                height="475"
              />
              <div style={{ width: '50%' }} />
            </section>


            <div className="mobile-step5">
              <Image
                alt="mobile_step5"
                src='/mobile_step5.svg'
                width={130}
                height={435}
              />
            </div>
            <section
              className="section"
              id="section5"
              style={{ marginTop: locale === 'en' ? '400px' : '300px' }}
            >
              <div
                className="text"
                style={{ marginTop: '-100px', width: '500px' }}
              >
                <h1 data-i18n="section4.h1">{t('section5.h1')}</h1>
                <p data-i18n="section4.p">{t('section5.p')}</p>
              </div>
              <Image
                alt="call"
                src="/call.png"
                width="550"
                height="450"
              />
            </section>
          </div>
        </main>

        <section className="partnership" ref={heroSection}>
          <h1 data-i18n="section4.h1">{t('partnership.h1')}</h1>

          <div className="steps">
            <div className="card">
              <Image
                alt="step1"
                src="/step1.png"
                width={286}
                height={192}
              />
              <div className="stage">1º</div>
              <h2 data-i18n="partnership.1.h2">{t('partnership.1.h2')}</h2>
              <p data-i18n="partnership.1.p">{t('partnership.1.p')}</p>
            </div>
            <div className="card">
              <Image
                alt="step2"
                src="/step2.png"
                width={286}
                height={192}
              />
              <div className="stage">2º</div>
              <h2 data-i18n="partnership.1.h2">{t('partnership.2.h2')}</h2>
              <p data-i18n="partnership.1.p">{t('partnership.2.p')}</p>
            </div>
            <div className="card">
              <Image
                alt="step3"
                src="/step3.png"
                width={286}
                height={192}
              />
              <div className="stage">3º</div>
              <h2 data-i18n="partnership.1.h2">{t('partnership.3.h2')}</h2>
              <p data-i18n="partnership.1.p">{t('partnership.3.p')}</p>
            </div>
          </div>

          <p style={{ fontWeight: 'bold' }} data-i18n="cta.p">
            {t('cta.p')}{' '}
          </p>
          <a
            onClick={() =>
              gaSendEvent(
                'CTA',
                'Quero me inscrever',
                'Home - middle como funciona'
              )
            }
            rel="noreferrer"
            className="btn blue"
            data-i18n="cta.a"
            href="/br/cadastro-de-parceria"
          >
            {t('cta.a')}
          </a>

          {locale === 'br' && (
            <>
              <h1
                data-i18n="journey.h1"
                className="partner"
                style={{
                  maxWidth: 1100,
                  textAlign: 'left'
                }}
              >
                <span
                  style={{
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: 24,
                    display: 'block',
                    marginBottom: 5,
                    color: '#2253F5'
                  }}
                >
                  Depoimentos
                </span>
                {t('journey.h1')}
              </h1>

              <div
                style={{
                  maxWidth: 1500,
                  margin: '0 0 0 auto'
                }}
              >
                <Slider {...settings1}>
                  <div>
                    <div className="tulio">
                      <p data-i18n="journey.helena">{t('journey.helena')}</p>
                      <div className="author">
                        <Image alt="helena" src="/helena.png" width={76} height={76} />
                        <div className='name'>
                          <h2>Helena Sordili</h2>
                          <span>Carranca Design</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="tulio">
                      <p data-i18n="journey.joyce">{t('journey.joyce')}</p>
                      <div className="author">
                        <Image alt="joyce" src="/joyce.png" width={76} height={76} />
                        <div className='name'>
                          <h2>Joyce Santos</h2>
                          <span>Digijoy</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="tulio">
                      <p data-i18n="journey.pedro">{t('journey.pedro')}</p>
                      <div className="author">
                        <Image alt="pedro" src="/pedro.png" width={76} height={76} />
                        <div className='name'>
                          <h2>Pedro Hiraoka</h2>
                          <span>Futturu Comunicação</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="tulio">
                      <p data-i18n="journey.tulio">{t('journey.tulio')}</p>
                      <div className="author">
                        <Image alt="tulio" src="/tulio.png" width={76} height={76} />
                        <div className='name'>
                          <h2>Tulio Brançam</h2>
                          <span>TBF Host</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
                <a
                  onClick={() =>
                    gaSendEvent(
                      'Link',
                      'Veja mais cases',
                      'Home - middle depoimentos'
                    )
                  }
                  rel="noreferrer"
                  href="/br/blog/categoria/case-de-sucesso"
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    marginLeft: 20,
                    marginTop: 56,
                    marginBottom: 56,
                    color: '#2253F5',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    fontSize: '24px',
                    textDecorationLine: 'underline',
                    width: 'unset'
                  }}
                >
                  Veja mais cases de sucesso
                  <FontAwesomeIcon
                    style={{
                      marginLeft: 10
                    }}
                    icon={faArrowRight}
                  />
                </a>
              </div>
            </>
          )}
        </section>
        {locale === 'br' && (
          <section className="hospedeirosAnonimos">
            <div>
              <div className="logos">
                <img alt="cloudezApresenta" className="cloudezApresenta" src="/cloudezApresenta.svg" />
                <img
                  alt="hospedeirosLogo"
                  className="hospedeirosLogo" src="/hospedeirosLogo.svg" />
              </div>
              <span>
                Um retrato leve e bem humorado dos “perrengues” enfrentados por
                agências digitais que ainda utilizam um modelo defasado de
                hospedagem.
              </span>
              <iframe
                onClick={() =>
                  gaSendEvent(
                    'Play',
                    'Vídeo Hospedeiros Anônimos',
                    'Home - middle Hospedeiros'
                  )
                }
                id="ytplayer"
                name="ytplayer"
                loading='lazy'
                src="https://www.youtube.com/embed/kVZ6AB6P-z4"
                frameBorder={0}
                title="Video Hospedeiros Anonimos"
              />
              <span>
                Se você ainda sofre com sites instáveis, clientes que ligam toda
                hora, disputa no mercado apenas por preços e não importa o quão
                bom é seu serviço não consegue entregar os melhores resultados
                aos clientes,{' '}
                <b>confira todos os vídeos da série e junte-se ao movimento</b>
              </span>
              <a
                onClick={() =>
                  gaSendEvent(
                    'CTA',
                    'Quero ver mais',
                    'Home - middle Hospedeiros'
                  )
                }
                rel="noreferrer"
                className="btn yellowLight"
                href="https://www.hospedeirosanonimos.com.br/uni-vos"
                target="_blank"
              >
                Quero ver mais
              </a>
            </div>
          </section>
        )}
        <section className="faq">
          <h1 data-i18n="faq.h1">{t('faq.h1')}</h1>

          <div className="tabs">
            <div className="tab">
              <div
                onClick={() =>
                  gaSendEvent(
                    'Accordion',
                    'Por que ',
                    'Home - Dúvidas frequentes'
                  )
                }
                className="collapsible"
                data-i18n="faq.1.collapsible"
              >
                {t('faq.1.collapsible')}
              </div>
              <div className="content">
                <p data-i18n="faq.1.p">{t('faq.1.p')}</p>
              </div>
            </div>
            <div className="tab">
              <div
                onClick={() =>
                  gaSendEvent('Accordion', 'Apoio', 'Home - Dúvidas frequentes')
                }
                data-i18n="faq.2.collapsible"
                className="collapsible"
              >
                {t('faq.2.collapsible')}
              </div>
              <div className="content">
                <p data-i18n="faq.2.p">{t('faq.2.p')}</p>
              </div>
            </div>
            <div className="tab">
              <div
                onClick={() =>
                  gaSendEvent(
                    'Accordion',
                    'Cliente final',
                    'Home - Dúvidas frequentes'
                  )
                }
                data-i18n="faq.3.collapsible"
                className="collapsible"
              >
                {t('faq.3.collapsible')}
              </div>
              <div className="content">
                <p data-i18n="faq.3.p">{t('faq.3.p')}</p>
              </div>
            </div>
          </div>

          <p style={{ fontWeight: 'bold' }} data-i18n="cta.p">
            {t('cta.p')}
          </p>

          <a
            onClick={() =>
              gaSendEvent(
                'CTA',
                'Quero me inscrever',
                'Home - Dúvidas frequentes'
              )
            }
            data-i18n="cta.a"
            rel="noreferrer"
            href="/br/cadastro-de-parceria"
            className="btn blue"
          >
            {t('cta.a')}
          </a>
        </section>
        {locale === 'br' && (
          <section className="cloudezMedia">
            <div>
              <span>
                Confira os <b>principais artigos e matérias</b> <br /> que
                saíram na mídia sobre a Cloudez
              </span>
              <a
                onClick={() =>
                  gaSendEvent('CTA', 'Ver a Cloudez na mídia', 'Home - Mídia')
                }
                data-i18n="hero-1.a"
                target="_blank"
                href="https://content.cloudez.io/cloudez-na-midia"
                className="btn"
              >
                Ver a Cloudez na mídia
              </a>
            </div>
          </section>
        )}

        {locale === 'br' && (
          <div className="section-posts">
            <h1 className="title">Conteúdos para especialistas digitais</h1>
            <div className="post">
              {posts.map((post) => {
                let titleTwoCategory = post.title.rendered;
                if (titleTwoCategory.length > 50) {
                  titleTwoCategory = `${titleTwoCategory.substring(0, 50)}...`;
                }

                let excerptTwoCategory = post.excerpt.rendered;
                if (excerptTwoCategory.length > 95) {
                  excerptTwoCategory = `${excerptTwoCategory.substring(
                    0,
                    95
                  )}...`;
                }

                return (
                  <div
                    onClick={() =>
                      gaSendEvent('Card', 'Ler artigo', 'Home - bottom')
                    }
                    className="cardblog"
                    key={post.slug}
                  >
                    <a href={`br/blog/${post.slug}`}>
                      <Image
                        src={
                          post._embedded?.['wp:featuredmedia'][0]?.source_url
                        }
                        width={330}
                        height={271}
                        alt={post._embedded?.['wp:featuredmedia'][0]?.alt_text}
                      />
                    </a>
                    <div className="card_items">
                      <span>
                        <Link
                          href={`br/blog/categoria/${post._embedded?.['wp:term'][0][0]?.slug}`}
                        >
                          {post._embedded?.['wp:term'][0][0]?.name}
                        </Link>
                      </span>

                      <a href={`br/blog/${post.slug}`}>
                        <h2
                          dangerouslySetInnerHTML={{
                            __html: titleTwoCategory
                          }}
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: excerptTwoCategory
                          }}
                        />
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Wrapper>
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context;

  if (locale === 'pt-BR') {
    return {
      notFound: true
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(locale.toString()))
    }
  };
};

export default Index;
